import { ContainerDetailsModel } from 'src/components/common/container-details/ContainerDetailsModel';

export enum MoveContainerMode {
    MOVE = 'MOVE',
    CONTAINERIZE = 'CONTAINERIZE',
    SORT = 'SORT'
}

export interface BatchMoveContainersInput {
    destinationContainer: string;
    movingContainers: ContainerDetailsModel[];
    warehouseId: string;
    associate: string;
    mode: MoveContainerMode;
    locale?: string;
    disableInventoryMovement?: boolean;
}

export interface FailedContainer {
    containerId: string;
}

export interface BatchMoveContainersOutput {
    failedContainers?: FailedContainer[];
}

export const buildBatchMoveContainersInput = (destinationContainer: string, movingContainers: ContainerDetailsModel[], mode: MoveContainerMode,
    warehouseId: string, associate: string, locale: string, disableInventoryMovement: boolean = true,
): BatchMoveContainersInput => {
    return {
        destinationContainer,
        movingContainers,
        warehouseId,
        associate,
        mode,
        locale,
        disableInventoryMovement
    }
}